/**
 * 直播列表搜索该条目
 * @param context
 * @param liveTitle
 */
export function go2LiveDetail(context, liveTitle) {
    context.$router.push({
        path: "/cloud_system_page/live_page/live_list_page",
        query: {
            searchValue: liveTitle,
        },
    });
}

/**
 * 往期回顾详情
 * @param context
 * @param liveId
 */
export function go2LiveReviewDetail(context, liveId) {
    context.$router.push({
        path: '/cloud_maili_page/liveReviewDetail',
        query: {
            liveID: liveId
        }
    })
}

/**
 * 视频课程详情
 * @param context
 * @param videoID
 */
export function go2LiveVideoDetail(context, videoID) {
    context.$router.push({
        path: "/cloud_maili_page/videoDetail",
        query: {
            videoID: videoID,
        },
    });
}

/**
 * 超人圈轮播图详情
 * @param context
 * @param forumGroupSliderImageId
 */
export function go2ForumGroupSlideImageDetail(context, forumGroupSliderImageId) {
    context.$router.push({
        path: "/cloud_system_page/forumGroupSliderImageDetail",
        query: {
            forumGroupSliderImageId: forumGroupSliderImageId,
        },
    });
}

/**
 * 设备管理
 * @param context
 * @param searchValue
 */
export function go2InstrumentSeries(context, searchValue) {
    context.$router.push({
        path: "/cloud_system_page/device_manager_page",
        query: {
            instrumentSeriesInitSearchValue: searchValue,
        },
    });
}

/**
 * 超人圈详情
 * @param context
 * @param searchValue
 */
export function go2UltrasonicDetail(context, forumId) {
    context.$router.push({
        path: "/cloud_maili_page/ultrasonicDetail",
        query: {
            forumId: forumId,
        },
    });
}

